import * as activityConst from "./constants";
import transform from "./transform";
import { makeCall } from "@/utils/request";
import { buildOptions, getEndPoints } from "@/utils/api-call";
import { EVENT_TOAST_MESSAGE } from "@/store/events";
import { EventBus } from "@/event-bus";
export const state = {
  activities: []
};

export const getters = {
  [activityConst.GETTER_LIST_ACTIVITY]: state => {
    return state.activities;
  }
};

export const actions = {
  [activityConst.ACTION_GET_LIST_ACTIVITY]: ({ commit }, options) => {
    const url = getEndPoints().program_activity.getProgramActivity.replace(
      ":id",
      options.programId
    );
    makeCall(url, buildOptions("GET", {}), commit).then(response => {
      if (response && response.data) {
        let transformList = transform.convertListMasterActivityToLevelActivityModel(
          response.data
        );
        commit(activityConst.MUTATION_SET_LIST_ACTIVITY, transformList);
      }
      if (options.callback) {
        options.callback();
      }
    });
  },
  [activityConst.ACTION_SET_LEVEL_ACTIVITIES_PURE]: ({ commit }, list) => {
    commit(activityConst.MUTATION_SET_LIST_ACTIVITY, list);
  },

  [activityConst.ACTION_SET_LEVEL_ACTIVITIES]: ({ commit }, options) => {
    let updateQueue = [];
    options.data.forEach(level => {
      if (level && level.Id > 0) {
        let updateItem = new Promise((resolve, reject) => {
          const url = getEndPoints().program_level_activities.addActivitiesToLevel.replace(
            ":id",
            level.Id
          );
          let listActivities = transform.convertListLevelActivityRawModel(
            level.Activities,
            level.Id
          );
          makeCall(url, buildOptions("POST", listActivities), commit).then(
            response => {
              resolve(response);
            },
            error => {
              console.log("error = ", error);
              reject(error);
            }
          );
        });
        updateQueue.push(updateItem);
      }
    });
    Promise.all(updateQueue).then(
      () => {
        if (options.callback) {
          EventBus.$emit(EVENT_TOAST_MESSAGE, options.successMessage);
          options.callback();
        }
      },
      error => {
        if (error && error.response) {
          options.errorHandling(error.response);
        }
      }
    );
  }
};

export const mutations = {
  [activityConst.MUTATION_SET_LIST_ACTIVITY]: (state, activities) => {
    state.activities = activities;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/basic_level_activities/index.js